module.exports = __webpack_public_path__ + "img/cap-40.a4cceb1b.png";